import React from 'react';

const ErrorPage = () => {
    return (
        <div>
            <div className='flex justify-center mt-10 '>
                <img className='w-3/5' src="https://www.cloudways.com/blog/wp-content/uploads/wordpress-404-error.jpg" alt="" />


            </div>
            <h1 className='text-center mt-6 text-red-500 text-5xl font-semibold'>Page is not found</h1>
        </div>
    );
};

export default ErrorPage;